import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppAuthGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(protected keycloakAngular: KeycloakService) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const url = `/${segments.map((segment) => segment.path).join('/')}`;
    return this.checkAuthAndRedirect(url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (childRoute.data?.['allowAnonymous']) {
      return of(true);
    }

    return this.checkAuthAndRedirect(state.url);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (route.data?.['allowAnonymous']) {
      return of(true);
    }

    return this.checkAuthAndRedirect(state.url);
  }

  private checkAuthAndRedirect(redirectUrl: string): Observable<boolean> {
    // Check if already authenticated
    if (this.keycloakAngular.isLoggedIn()) {
      return of(true);
    }

    // Not authenticated, trigger login redirect
    this.keycloakAngular.login({
      redirectUri: globalThis.location.origin + redirectUrl,
    });

    // Return false to prevent navigation (login will redirect)
    return of(false);
  }
}
